import AIEduDataTable from '../../components/DataTable/AIEduDataTable';
import styles from './ActivityLogs.module.css';
import {
    convertSecondsToTimeStamp,
    formatDateWithTimeStamp,
} from '../../utils/Utils';

const UserSession = ({
    f,
    data,
    sortField,
    sortOrder,
    onSort,
    sortIcon,
    dataKey,
}) => {
    const loginTimeTemplate = (rowData) => {
        return !!rowData.loginTime
            ? formatDateWithTimeStamp(rowData.loginTime)
            : '--';
    };

    const logoutTimeTemplate = (rowData) => {
        return !!rowData.logoutTime
            ? formatDateWithTimeStamp(rowData.logoutTime)
            : '--';
    };

    const sessionDurationTemplate = (rowData) => {
        return !!rowData.duration
            ? convertSecondsToTimeStamp(rowData.duration)
            : '00:00:00';
    };

    const emailTemplate = (rowData) => {
        return (
            <div
                className={styles.user_email_template}
                title={rowData.userEmail}
            >
                {rowData.userEmail}
            </div>
        );
    };

    const columns = [
        {
            field: 'userEmail',
            header: f({ id: 'AI_EDU_USER_EMAIL' }),
            body: emailTemplate,
            sortable: true,
            width: '25%',
            minWidth: '20rem',
        },
        {
            field: 'userName',
            header: f({ id: 'AI_EDU_USER_NAME' }),
            sortable: true,
            width: '20%',
            minWidth: '15rem',
        },
        {
            field: 'screenId',
            header: f({ id: 'AI_EDU_DEVICE_MAC' }),
            sortable: true,
            width: '15%',
            minWidth: '10rem',
        },
        {
            field: 'loginTime',
            header: f({ id: 'AI_EDU_LOGIN_TIME' }),
            body: loginTimeTemplate,
            sortable: true,
            width: '15%',
            minWidth: '10rem',
        },
        {
            field: 'logoutTime',
            header: f({ id: 'AI_EDU_LOGOUT_TIME' }),
            body: logoutTimeTemplate,
            sortable: true,
            width: '15%',
            minWidth: '10rem',
        },
        {
            field: 'duration',
            header: f({ id: 'AI_EDU_SESSION_DURATION' }),
            body: sessionDurationTemplate,
            sortable: true,
            minWidth: '10rem',
        },
    ];

    return (
        <AIEduDataTable
            key={dataKey}
            data={data}
            columns={columns}
            sortField={sortField}
            sortOrder={sortOrder}
            sortIcon={sortIcon}
            onSort={onSort}
            lazy={true}
            scrollHeight='60vh'
            emptyMessage={f({ id: 'AI_EDU_NO_DATA_TO_SHOW' })}
        />
    );
};

export default UserSession;
